import { Route, Routes } from 'react-router-dom';

import { LoginCard, OnboardingLayout } from '../ui';

import EditTariffContainer from './Edit/EditTariffContainer';
import SmartTariffSwitchWarning from './Edit/SmartTariffSwitchWarning';
import SubscribeContainer from './Edit/SubscribeContainer';
import { SuccessContainer } from './Onboarding';

const EditContainer = () => (
  <OnboardingLayout backgroundTint="blue">
    <LoginCard>
      <Routes>
        <Route path="tariff" element={<EditTariffContainer />} />
        <Route path="smart-tariff-switch-warning" element={<SmartTariffSwitchWarning />} />
        <Route path="subscribe" element={<SubscribeContainer />} />
        <Route path="check-subscription" element={<SuccessContainer />} />
      </Routes>
    </LoginCard>
  </OnboardingLayout>
);

export default EditContainer;
